// extracted by mini-css-extract-plugin
export default {"formContainer":"styles_formContainer__r7Eyp","highlightSection":"styles_highlightSection__dva8B highlightSection","disclosure":"styles_disclosure__NSMT+"};